export const terrabaseUrl = process.env?.REACT_APP_TB_API_URL ? process.env.REACT_APP_TB_API_URL : "http://localhost/creator";